export default __webpack_public_path__ + "static/media/Licence.558455ec.jpg";